const Partners = () => {
  return (
    <div className="container my-5">
        <div className="row">
        <div className="col-lg-2 col-4">
        <img className="img-fluid" src="https://safemoon.com/_next/image?url=%2Fimg%2Fbrands%2Fbscscan.png&w=256&q=75" alt="" />
        </div>
        <div className="col-lg-2 col-4">
        <img className="img-fluid" src="https://safemoon.com/_next/image?url=%2Fimg%2Fbrands%2Fcertik.png&w=256&q=75" alt="" />
        </div>
        <div className="col-lg-2 col-4">
        <img className="img-fluid" src="https://safemoon.com/_next/image?url=%2Fimg%2Fbrands%2Fnomics.png&w=256&q=75" alt="" />
        </div>
        <div className="col-lg-2 col-4">
        <img className="img-fluid" src="https://safemoon.com/_next/image?url=%2Fimg%2Fbrands%2Fcoinmarket.png&w=256&q=75" alt="" />
        </div>
        <div className="col-lg-2 col-4">
        <img className="img-fluid" src="https://safemoon.com/_next/image?url=%2Fimg%2Fbrands%2Fcoingecko.png&w=256&q=75" alt="" />
        </div>
        <div className="col-lg-2 col-4">
        <img className="img-fluid" src="https://safemoon.com/_next/image?url=%2Fimg%2Fbrands%2Fwatcher.png&w=256&q=75" alt="" />
        </div>
        
        </div>
    </div>
  )
}
export default Partners